export default {
  methods: {
    downloadCsvFile(csvContent, fileName) {
      const hiddenLink = document.createElement('a');
      hiddenLink.style = 'display: none';

      document.body.appendChild(hiddenLink);
      window.URL = window.webkitURL || window.URL;

      const url = window.URL.createObjectURL(new Blob([csvContent], { type: 'text/csv' }));
      hiddenLink.href = url;
      hiddenLink.download = fileName;
      hiddenLink.click();

      window.URL.revokeObjectURL(url);
      hiddenLink.remove();
    },
  },
};
